<div class="flex items-center">
    <div class="grow">
        <ng-container #fieldComponent></ng-container>
    </div>
    <p-button
        pTooltip="{{ 'common.persist-field-hint' | translate }}"
        (onClick)="persist()"
        icon="fa-solid fa-thumbtack {{ isPersisted ? 'fa-rotate-90' : '' }} {{
            isPersisted ? 'text-muted-color' : ''
        }}"
        text="true"
    >
    </p-button>
</div>
